import { useState, useCallback, ReactNode } from 'react';
import { WaitingNode } from '../components/waitingNode/WaitingNode';

export function useAsyncStatus<TArgs extends any[], TResult>() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const run = useCallback(
    async (asyncFn: (...args: TArgs) => Promise<TResult>, ...args: TArgs) => {
      setLoading(true);
      setError(null);
      try {
        return await asyncFn(...args);
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const waitingNode = loading ? <WaitingNode /> : <></>

  return {
    run,
    loading,
    error,
    waitingNode,
  };
}
